import { ColDef } from 'ag-grid-community'
import clsx from 'clsx'

import { CurrencyCell, Table, UnitsCell } from '@/components/core-v2'

import { Order } from './orders-types'

interface OrderTradesProps {
  order: Order
}

export const CORE_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Trade',
    field: 'accountName',
    flex: 0.3
  },
  {
    headerName: 'Status',
    field: 'accountStatus',
    flex: 0.2
  },
  {
    headerName: 'Business unit',
    field: 'businessUnitName',
    flex: 0.3
  }
]

export const BUY_COLUMN_DEFS: ColDef[] = CORE_COLUMN_DEFS.concat({
  headerName: 'Amount',
  field: 'value',
  cellRenderer: CurrencyCell({ fieldName: 'value' }),
  flex: 0.2
})

export const SELL_COLUMN_DEFS = CORE_COLUMN_DEFS.concat({
  headerName: 'Units',
  field: 'shares',
  cellRenderer: UnitsCell({ fieldName: 'shares' }),
  flex: 0.2
})

export const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: true,
  unSortIcon: true,
  wrapText: false,
  autoHeight: true
}

export const OrderTrades = ({ order }: OrderTradesProps) => (
  <Table
    data-private
    agGridProps={{
      columnDefs: order.direction === 'Subscription' ? BUY_COLUMN_DEFS : SELL_COLUMN_DEFS,
      defaultColDef: DEFAULT_COLUMN_OPTIONS,
      headerHeight: 40,
      rowData: order.individualOrders,
      rowHeight: 60
    }}
    className={clsx('mx-5 mt-5')}
    height="250px"
  />
)
